import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserDashboardService {
  private _createDashboardEnabled = signal<boolean>(false);

  constructor() {}

  public get createDashboardEnabled(): WritableSignal<boolean> {
    return this._createDashboardEnabled;
  }

  setCreateDashboardEnabled(enabled: boolean): void {
    this._createDashboardEnabled.set(enabled);
  }
}
